import React, { createRef } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { ListView } from '@tencent/ptp-fe-common';
import { PopOver, OverlayTrigger } from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';
import { DateUtil } from '../../../utils/DateUtil';
import { getSelectOptionsFromMap } from '../../../utils/ListUtil';
import {
  LeadsSource,
  LeadsOperationType,
  LeadsComeFrom,
} from '../../../consts/leadsLogs';
import useCustomColumn from '../../hooks/useCustomFilter';
import { LeadsDataFilterShortcut } from '../../../consts/Common';
import { beaconInstance } from '../../../instrumentation/beaconSetup';
import { withNetCall } from '../../common/call/withNetCall';

const datePickerConfig = {
  type: 'range',
  useShortcut: true,
  longestRange: 365,
  optionalStartDate: '2018-06-01',
  shortcuts: LeadsDataFilterShortcut,
};

const oprateTypeConfig = {
  data: getSelectOptionsFromMap(LeadsOperationType),
};

const sourceConfig = {
  data: getSelectOptionsFromMap(LeadsSource),
};

// 仅超级管理员、管理员、免登录有权限查看操作日志
export const canIUseLogs = () => [
  'OPERATOR_ROLE_LEADS_MANAGER',
  'OPERATOR_ROLE_LEADS_CMANAGER',
  'OPERATOR_ROLE_LEADS_OBSERVER',
  'OPERATOR_ROLE_LEADS_SUPER_OBSERVER',
].includes(window.pageProps.operatorRole);

export class Logs extends React.Component {
  lvObj = createRef();

  initQuery = {
    createdTime: {
      start_time: moment().subtract(6, 'day').format('YYYY-MM-DD'),
      end_time: moment().format('YYYY-MM-DD'),
    },
    queryAccountId: window.pageProps.uid,
  };

  state = {
    /**
     *  搜索区
     */
    pageSize: 10,
    pageIndex: 1,
    startDate: DateUtil.getWeekAgoDateStr(),
    endDate: DateUtil.getTodayDateStr(),

    // 表格
    data: [],
    accountId: this.initQuery.queryAccountId,
    operatorMap: {},

    inited: false,
  };

  constructor(props) {
    super(props);
    // 获取初始账号ID下面的员工列表
    this.getEmployeeList(this.initQuery.queryAccountId);
  }

  componentDidMount() {
    beaconInstance.onUserAction(
      'page_view',
      { page: '操作日志' },
    );
  }

  render() {
    return (
      <div className="main">
        <div className="page-log">
          <div className="card logs-page" style={{ paddingTop: 0, margin: 30 }}>
            <div className="datalist">
              <ListView
                className="lv"
                ref={this.lvObj}
                options={this.lvOptions}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  getEmployeeList(accountId) {
    const arr = this.state.operatorMap[accountId];
    if (Array.isArray(arr)) return;
    RPCFactory.logs.getEmployeeList(accountId)
    .done((data) => {
      let list = data || [];
      list = list.map((item) => ({
        label: item.name,
        value: item.userId,
      }));
      this.setState({
        operatorMap: { ...this.state.operatorMap, [accountId]: list },
      });
    });
  };

  /**
   * ListView 需要的数据
   */

  getList = (params) => new Promise((res, rej) => {
    const report = (status) => {
      if (!this.state.inited) {
        this.setState({ inited: true });
        return;
      }
      beaconInstance.onUserAction(
        'filter_change',
        {
          page: '操作日志',
          name: '操作日志筛选',
          network: status,
        },
      );
    };
    RPCFactory.logs.getLogList(params).done((data) => {
      report('success');
      this.setState({
        data: data.entities,
        totalSize: data.size,
      });
      const leadsData = {
        list: [],
        page_info: {
          total_number: 0,
        },
      };
      leadsData.list = data.entities;
      leadsData.page_info.total_number = data.size;
      res(leadsData);
    })
    .fail((ret, msg) => {
      report('fail');
      rej(msg);
    });
  }).catch(console.log);

  getAllFilterConfig = () => {
    // 自定义筛选项配置
    const defaultFilterKeys = ['createdTime', 'operationType', 'queryAccountId', 'source', 'operatorIds'];
    this.customFilterConfigure = useCustomColumn({
      defaultFilterKeys,
      controls: this.filterControls,
      storageKey: 'ams:user_profile:advertiser_custom_filters_/adhome/advertiser/logs',
    });
    delete this.customFilterConfigure.customFilterComponent;
  };

  renderSource(type, name, value, data) {
    return LeadsSource[data.source];
  };

  renderType(type, name, value, data) {
    return LeadsOperationType[data.operateType] || '-';
  };

  renderName(type, name, value, data) {
    const _name = data.name || data.wxId || data.qq;
    if (_name) return _name;
    return LeadsComeFrom[data.comeFrom] || '-';
  };

  renderContent(type, name, value, data) {
    const overlay = (<PopOver>{ data.detail }</PopOver>);
    return (
      <OverlayTrigger trigger="hover" overlay={overlay}>
        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
          { data.detail }
        </div>
      </OverlayTrigger>
    );
  };

  getShowColumns = () => {
    this.showColumns = [
      { name: 'operationType', title: '操作人', render: this.renderName, minWidth: 270 },
      { name: 'operationTypeName', title: '操作行为名称', render: this.renderType, minWidth: 150 },
      { name: 'detail', title: '操作内容', render: this.renderContent, maxWidth: 700 },
      { name: 'source', title: '操作端', render: this.renderSource, minWidth: 120 },
      { name: 'createdTime', title: '操作时间', minWidth: 150 },
    ];
  };

  lvOptions = () => {
    let accId = this.state.accountId;
    const subAccountIds = window.pageProps.sub_account_ids || [];
    const mpSubAccountIds = window.pageProps.mp_sub_account_ids || [];
    const idList = [
      window.pageProps.uid,
      ...subAccountIds,
      ...mpSubAccountIds,
    ].map((value) => ({ value, label: value }));
    const accountConfig = {
      data: idList,
      onChange: (_, value) => {
        accId = value;
        if (value === this.state.accountId) return;
        this.setState({ accountId: value });
        this.getEmployeeList(value);
        this.lvObj.current.setFilterData({
          ...this.lvObj.current.filterData,
          operatorIds: [],
        });
      }
    };
    const operatorConfig = {
      multiple: true,
      data: _.get(this.state, ['operatorMap', accId], []),
    }
    this.filterControls = [
      { name: 'createdTime', title: '操作时间', type: 'date-picker', clearble: false, config: datePickerConfig },
      { name: 'operationType', title: '操作行为', type: 'select', config: oprateTypeConfig },
      { name: 'operatorIds', title: '操作人', type: 'select', config: operatorConfig },
      { name: 'source', title: '操作端', type: 'select', config: sourceConfig },
      { name: 'queryAccountId', title: '账号ID', type: 'select', clearable: false, config: accountConfig },
    ];

    this.getAllFilterConfig();
    this.getShowColumns();

    return {
      fetchConfig: {
        action: this.getList,
        $onRequest: (params) => {
          const obj = { ...params };
          delete obj.createdTime;
          delete obj.page_size;
          delete obj.page;
          obj.pageIndex = params.page;
          obj.pageSize = params.page_size;
          if (params.createdTime) {
            obj.startDate = params.createdTime.start_time;
            obj.endDate = params.createdTime.end_time;
          }
          if (Array.isArray(params.operatorIds)) {
            if (params.operatorIds.length < 1) {
              delete obj.operatorIds;
            } else {
              obj.operatorIds = JSON.stringify(params.operatorIds);
            }
          }
          return obj;
        },
        $onResponse: (data) => {
          return data;
        },
        $onError: window.alert,
      },
      toolbarConfig: {
        left: (
          <div className="toolbar-left">
            <h4>操作日志</h4>
          </div>
        ),
        right: null,
      },
      filterConfig: {
        resetable: false,
        controls: this.filterControls,
        customConfigure: this.customFilterConfigure,
        defaultValuesByKey: this.initQuery,
      },
      batchConfig: null,
      tableConfig: {
        defaultPageSize: 10,
        select: null,
        optionalConfig: {},
        columns: this.showColumns,
        className: 'log-table',
      },
    };
  };
}

export const OperateLogs = withNetCall(Logs);
